// Phone quick-actions bar (templates/_header.twig). An inline script arms it (hidden, inert) before first paint, so
// visitors first see the header on its own; it slides up once they've scrolled past SHOW_AFTER and slides away again
// back near the top. Without JS the bar is never armed and stays visible.

const SHOW_AFTER = 240; // px scrolled

const bar = document.querySelector('[data-mobile-actionbar].is-armed');

if (bar) {
    let visible = false;
    let ticking = false;

    const update = () => {
        ticking = false;
        const show = window.scrollY > SHOW_AFTER;
        if (show === visible) return;
        visible = show;
        bar.classList.toggle('is-visible', show);
        bar.inert = !show;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }, { passive: true });
    update(); // a reload or #anchor may land mid-page
}
